var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-flex-center" },
    [
      _vm.hours
        ? [
            _c(
              "yxt-select",
              {
                staticClass: "yxtbiz-w70 mr8",
                model: {
                  value: _vm.h,
                  callback: function ($$v) {
                    _vm.h = $$v
                  },
                  expression: "h",
                },
              },
              [
                _c("yxt-option", { attrs: { value: 0, label: "00" } }),
                _vm._l(_vm.hours, function (item) {
                  return _c("yxt-option", {
                    key: item,
                    attrs: { value: item, label: item > 9 ? item : "0" + item },
                  })
                }),
              ],
              2
            ),
            _c("span", { staticClass: "mr12" }, [
              _vm._v(_vm._s(_vm.$t("pc_kng_detail_lbl_hour" /** 小时 */))),
            ]),
          ]
        : _vm._e(),
      _c(
        "yxt-select",
        {
          staticClass: "yxtbiz-w70 mr8",
          model: {
            value: _vm.m,
            callback: function ($$v) {
              _vm.m = $$v
            },
            expression: "m",
          },
        },
        [
          _c("yxt-option", { attrs: { value: 0, label: "00" } }),
          _vm._l(_vm.minutes, function (item) {
            return _c("yxt-option", {
              key: item,
              attrs: { value: item, label: item > 9 ? item : "0" + item },
            })
          }),
        ],
        2
      ),
      _vm._v(_vm._s(_vm.$t("pc_kng_detail_lbl_minute" /** 分钟 */)) + "\n  "),
      _c(
        "yxt-select",
        {
          staticClass: "yxtbiz-w70 ml12 mr8",
          model: {
            value: _vm.s,
            callback: function ($$v) {
              _vm.s = $$v
            },
            expression: "s",
          },
        },
        [
          _c("yxt-option", { attrs: { value: 0, label: "00" } }),
          _vm._l(_vm.seconds, function (item) {
            return _c("yxt-option", {
              key: item,
              attrs: { value: item, label: item > 9 ? item : "0" + item },
            })
          }),
        ],
        2
      ),
      _vm._v(_vm._s(_vm.$t("pc_kng_detail_lbl_second" /** 秒 */)) + "\n  "),
      !_vm.insertHidden
        ? _c(
            "yxt-button",
            {
              staticClass: "ml12",
              attrs: { disabled: _vm.insertDisabled },
              on: { click: _vm.insertCurrent },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("pc_biz_btn_insertcurrenttime" /** 插入当前时间 */)
                )
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }